import type { ViewMode } from './viewMode'

/**
 * Would staging text into this pane right now lose it?
 *
 * An agent CLI that has stopped at a prompt — a permission/approval box, a
 * workspace-trust confirm, a numbered yes/no menu — is reading keys as MENU
 * NAVIGATION, not as text. Writing a message into it does not queue anything: the
 * characters are consumed as selection keys, the composer clears because staging
 * "succeeded", and the message is gone. The server has reported the state as
 * `needs_input` all along; nothing read it.
 *
 * THE VIEW IS HALF THE CONDITION, and it is the half that makes this a bug rather
 * than a fact of terminals. In terminal-view the prompt is on screen: the keys are
 * the answer, the user can see what they are answering, and that is exactly what
 * they meant to do. In a rich view the prompt is not rendered at all — the same
 * keystrokes are a message that vanishes with nothing on screen to explain where it
 * went.
 *
 * Deliberately NOT gated on `status === 'active'`. A busy agent is a reason to wait,
 * not a reason to lose what you typed, and the server already gates `needs_input` on
 * not-active — a streaming pane is not blocked on input.
 */
export function swallowsTyping(needsInput: boolean, mode: ViewMode): boolean {
  return needsInput && mode !== 'terminal-view'
}

/**
 * NOT AUTO-OPENED, and this is the note that keeps it that way.
 *
 * The sheet briefly opened itself on the rising edge of this guard. It was removed on
 * the owner's report, and the reason generalises past this feature: a modal that
 * appears over someone mid-sentence takes the keystroke their next character was
 * going to, and the Escape that dismisses it is the same key that cancels a
 * selection. The thing meant to stop input being lost was losing input.
 *
 * So being TOLD is separate from being INTERRUPTED. The announcement is a button that
 * changes colour — it already occupies its space, so lighting it up moves nothing and
 * steals no focus — and opening the sheet stays a decision. An earlier version put a
 * banner above the composer, which was better than a modal and still wrong: it pushed
 * the composer down under the user's hands as they typed.
 */
